"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEstablishmentMethodByKey = exports.establishment_method_list = exports.establishment_methods = void 0;
const util_1 = require("./util");
exports.establishment_methods = [
    { key: 'direct_planting', tupuake_id: 1, display_name: 'Direct Planting' },
    { key: 'natural_regeneration', tupuake_id: 2, display_name: 'Natural Regeneration' },
];
// Current rotation establishment method
exports.establishment_method_list = exports.establishment_methods.map((sp) => sp.key);
exports.getEstablishmentMethodByKey = (0, util_1.createFindByKeyUsingArray)(exports.establishment_methods, 'establishment_method');
